import { useQuery, UseQueryOptions } from '@tanstack/react-query'

import { getUserAgreements as fetchUserAgreements } from '@/ports'
import useCurrentSession from '@/hooks/use-current-session'

interface AgreementsMismatchResponse {
  mismatched: { [key: string]: any }
  latestAgreements: { [key: string]: any }
}
interface UserAgreementsResponse {
  agreements: { [key: string]: any }
  user_agreements: { [key: string]: any }
}

export const getUserAgreementsMismatched =
  async (): Promise<AgreementsMismatchResponse> => {
    const response = await fetchUserAgreements()

    const data = response?.body as UserAgreementsResponse

    const newestAgreements = data?.agreements || {}
    const currentAgreements = data?.user_agreements || {}

    const mismatched: { [key: string]: any } = {}
    Object.keys(newestAgreements).forEach(key => {
      const newestAgreement = newestAgreements[key]
      const currentAgreement = currentAgreements[key]

      if (!currentAgreement) {
        mismatched[key] = newestAgreement
      }

      if (
        currentAgreement?.system_agreement_version !== newestAgreement?.version
      ) {
        mismatched[key] = newestAgreement
      }
    })

    return { mismatched, latestAgreements: newestAgreements }
  }

export const useGetUserAgreementsMismatched = (
  props: UseQueryOptions<AgreementsMismatchResponse>
): any => {
  const session = useCurrentSession()
  const userId = session?.id

  const { data, isLoading, refetch, isFetched, ...rest } = useQuery({
    queryKey: ['user-agreements-mismatched', userId],
    queryFn: getUserAgreementsMismatched,
    staleTime: 3 * 1000000,
    ...props
  })

  return {
    ...rest,
    mismatched: data?.mismatched,
    latestAgreements: data?.latestAgreements,
    isLoading,
    refetch,
    isFetched
  }
}
